import React from 'react';
import NewReleases from '@mui/icons-material/NewReleases';
import Tooltip from '@mui/material/Tooltip';
import useTheme from '@mui/material/styles/useTheme';
import { PropTypes } from 'prop-types';

const PendingRestrictionsFilter = ({ states, setStates }) => {
  const theme = useTheme();
  const { filterByPendingRestrictions = false, ...rest } = states;

  return (
    <Tooltip title="Filtrar por Restricciones Pendientes">
      <NewReleases
        sx={{
          width: 25,
          height: 25,
          cursor: 'pointer',
          color: filterByPendingRestrictions
            ? theme.palette.error.A600 : theme.palette.gray.A600,
        }}
        onClick={() => {
          setStates({
            ...rest,
            filterByPendingRestrictions: !filterByPendingRestrictions,
          });
        }}
      />
    </Tooltip>
  );
};

PendingRestrictionsFilter.propTypes = {
  states: PropTypes.shape({
    filterByPendingRestrictions: PropTypes.bool,
  }).isRequired,
  setStates: PropTypes.func.isRequired,
};

export default PendingRestrictionsFilter;
